import { useRef } from "react";
import { ArrowButton } from "../../../../../components/features/ArrowButton";
import { OtherProductCard } from "../OtherProductCard";
import { ProfilerProduct } from "@/features/profiler/types/ProfilerProduct";

type RecommendedProductsProps = {
  alsoLikeFeticheFragrance: ProfilerProduct;
  alsoLikeLoubiworldFragrance: ProfilerProduct;
};

export const RecommendedProducts = ({ alsoLikeFeticheFragrance, alsoLikeLoubiworldFragrance }: RecommendedProductsProps) => {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  return (
    <>
      <div className="flex justify-between items-end self-stretch">
        <p className="text-[#050505] text-center font-minion text-[26px] font-normal">
          You should also like...
        </p>
        <ArrowButton
          ariaLabel="Scroll products right"
          scrollContainerRef={scrollContainerRef}
        />
      </div>
      <div className="w-full pb-10">
        <div ref={scrollContainerRef} className="flex gap-4 overflow-x-auto">
          <OtherProductCard
            name={alsoLikeFeticheFragrance.label}
            imagePath={`/fragrance-profiler/secondary-fragrances/${alsoLikeFeticheFragrance.id}.png`}
            watchTutorial={false}
          />
          <OtherProductCard
            name={alsoLikeLoubiworldFragrance.label}
            imagePath={`/fragrance-profiler/secondary-fragrances/${alsoLikeLoubiworldFragrance.id}.png`}
            watchTutorial={false}
          />
        </div>
      </div>
    </>
  );
};
